import React, { forwardRef } from 'react';
import { FiCheck } from 'react-icons/fi';

const Checkbox = forwardRef(({
  checked = false,
  onChange,
  name,
  id,
  disabled = false,
  label,
  className = '',
  ...props
}, ref) => {
  return (
    <label className={`flex items-center gap-3 cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}>
      <div className="relative">
        <input
          ref={ref}
          type="checkbox"
          name={name}
          id={id || name}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className="sr-only peer"
          {...props}
        />
        <div className={`
          h-5 w-5 rounded border-2 transition-all duration-200
          flex items-center justify-center
          ${checked
            ? 'bg-brand-500 border-brand-500'
            : 'border-stroke bg-transparent dark:border-strokedark'
          }
          peer-focus:ring-2 peer-focus:ring-brand-500/20
          peer-disabled:opacity-50
        `}>
          {checked && <FiCheck size={14} className="text-white" />}
        </div>
      </div>
      {label && (
        <span className="text-sm text-black dark:text-white">{label}</span>
      )}
    </label>
  );
});

Checkbox.displayName = 'Checkbox';

export default Checkbox;
